<template>
   <div>
   <div class="page page1">
    <div class="tvBox">
    <img class="tv" src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/tv.png" alt="">
    <img class="playIcon animated pulse infinite" src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/playIcon.png" alt="">
    </div>
    <div class="food"></div>
    <div class="animal"></div>
    <div class="decoration"></div>
    <div class="btnBox">
        <!-- <div class="root-wx-open-launch-app">
            <img src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/android_Button.png" alt="">
        </div> -->
        <!-- <div class="iosButton">
            <img src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/android_Button.png" alt="">
        </div> -->
        <div class="root-wx-open-launch-app">
            <img src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/android_Button.png" alt="">
        </div>
    </div>
  </div>
  <div class="page page2">
  <div class="lunboArea">
    <!-- <div class="swiper-container" id="lunboContainer"> -->
      <!-- <div class="swiper-wrapper"> -->
        <!-- <div class="swiper-slide">
          <img src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/1242x2208-1.jpg" alt="">
        </div>
        <div class="swiper-slide">
          <img src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/1242x2208-2.jpg" alt="">
        </div>
        <div class="swiper-slide">
          <img src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/1242x2208-3.jpg" alt="">
        </div>
        <div class="swiper-slide">
          <img src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/1242x2208-4.jpg" alt="">
        </div>
        <div class="swiper-slide">
          <img src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/1242x2208-5.jpg" alt="">
        </div>
        <div class="swiper-slide">
          <img src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/1242x2208-6.jpg" alt="">
        </div> -->
        <el-carousel :interval="2000" type="card" id="lunboContainer" class="swiper-container" height="18rem">
            <el-carousel-item v-for="item in imglist" :key="item.key">
                <div class="swiper-slide">
                    <img :src="item.value" alt="">
                </div>
            </el-carousel-item>
        </el-carousel>
      <!-- </div> -->
      <!-- <div class="arrowBox">
        <img src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/arrow_pre.png" class="pre_button" alt="">
        <img src="https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/arrow_next.png" class="next_button" alt="">
      </div> -->
    <!-- </div> -->
  </div>
</div>
  </div>
</template>

<script>
import { createWXOpenTag } from '../units.js'
export default {
    data() {
        return {
            imglist: [
                {value: "https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/1242x2208-1.jpg", key: "img1"},
                {value: "https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/1242x2208-2.jpg", key: "img2"},
                {value: "https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/1242x2208-3.jpg", key: "img3"},
                {value: "https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/1242x2208-4.jpg", key: "img4"},
                {value: "https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/1242x2208-5.jpg", key: "img5"},
                {value: "https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/1242x2208-6.jpg", key: "img6"},    
            ]
        }
    },
    metaInfo: {
        meta: [
            { charset: 'utf-8' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0' },
            { name: 'apple-mobile-web-app-capable', content: 'yes' },
            { name: 'format-detection', content: 'telephone=no' },
            {'http-equiv': 'X-UA-Compatible', content: 'IE=Edge,Chrome=1'},
        ]  
    },
    methods: {
        // appRedict() {
        //     console.log("appRedict");
        //     createWXOpenTag();
        // }   
    },
     mounted() {
         createWXOpenTag()
     }
}
</script>

<style scoped>
@import "https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/index.css";

.page1 {
    background-image: url("https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/background_01.png");
}
.page1 .food {
    background-image: url("https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/food_01.png");
}
.page1 .animal {
    bottom: 2.4rem;
    background-image: url('https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/animal.png');
}
.page2 {
      background-image: url("https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0/background_02.jpg");
    }
.page1 .decoration {
    background-image: url("https://restaurant-1257666530.cos.ap-chengdu.myqcloud.com/appWxShare/1.0//bottem.png");
}
.page1 .btnBox .iosButton img, .root-wx-open-launch-app img {
    width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/restaurant.vue